import classNames from 'classnames'
import BaseSelect, { BaseSelectProps } from './BaseSelect'
import LabelControl from './LabelControl'
import { ZodIssue } from 'zod'
import useZodErrorParse from 'hooks/useZodErrorParse'
import InlineErrorWrapper from './InlineErrorWrapper'

interface SelectFieldProps extends BaseSelectProps {
  labelKey?: string,
  className?: string,
  errors?: ZodIssue[]
}

const SelectField = (props: SelectFieldProps) => {
  const { fieldId, labelKey, className, errors = [] } = props
  const { isError, errorCode } = useZodErrorParse(errors, fieldId)

  return (
    <div className={classNames("input-container mb-3 position-relative", className, { "error": isError })} >
      <LabelControl fieldId={fieldId} labelKey={labelKey} />
        <BaseSelect {...props} />
      <InlineErrorWrapper errorCode={errorCode} />
    </div>
  )
}

export default SelectField